module.exports = prestashop;


//////////////////
// WEBPACK FOOTER
// external "prestashop"
// module id = 53
// module chunks = 0